/**
 * Created by gaupoit on 4/3/17.
 */

const { api_url } = pda_gold_v3_data;
const restApiRoot = api_url.replace(/\/$/, '');

export const AXIOS_CONFIG = function() {
    return {
        baseURL: `${restApiRoot}/pda/v3/`,
        timeout: 10000, //milisecond
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
            'X-WP-Nonce': pda_gold_v3_data.nonce
        }
    }
}

export const AXIOS_CONFIG_PDA_LITE = function() {
    return {
        baseURL: `${restApiRoot}/pda-lite/v1/`,
        timeout: 10000, //milisecond
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
            'X-WP-Nonce': pda_gold_v3_data.nonce
        }
    }
}

export const API_CONFIGS = {
    PROTECT_FILE:  (id) => `files/${id}`,
    UN_PROTECT_FILE:  (id) => `un-protect-files/${id}`,
    FETCH_PRIVATE_URLS: (id) => `private-urls/${id}`,
    CREATE_PRIVATE_URLS: (id) => `private-urls/${id}`,
    BULK_CREATE_PRIVATE_URLS: (id) => `private-urls/${id}/bulk`,
    GET_PAGE_PRIVATE_URLS: 'pages/private-urls',
    GET_POST_PRIVATE_URLS: 'posts/private-urls',
    CREATE_PAGE_PRIVATE_URLS: 'pages/private-urls',
    CREATE_POST_PRIVATE_URLS: 'posts/private-urls',
    DELETE_PRIVATE_URL: (id) => `delete-private-urls/${id}`,
    UPDATE_PRIVATE_URL: (id) => `private-urls/${id}/update`,
    CUSTOM_PRIVATE_URL: (id) => `private-urls/${id}/custom`,
    UPDATE_DATA_PRIVATE_URL: (id) => `update-private-urls/${id}`,
    IS_PROTECTED_FILE: (id) => `files/${id}`,
    SET_DEFAULT: (id) => `set-default/${id}`,
    'IP_BLOCK': (post_id) => `pda-ip-block/${post_id}`,
    'GET_IP_BLOCK': (post_id) => `pda-get-ip-block/${post_id}`,

    'GET_USER_ROLES_IP_BLOCK': (post_id) => `pda-get-user-roles-ip-block/${post_id}`,
    'PDA_GET_FILE_ACCESS_PERMISSIONS': (post_id) => `get-file-access-permissions/${post_id}`,
    GET_ALL_USER_ROLES: 'get-user-roles',

    'ADD_USER_ROLES': (post_id) => `pda-insert-user-roles/${post_id}`,
    'PDA_ADD_USER_ROLES': (post_id) => `add-user-roles/${post_id}`,

    'PRIVATE_SUMMARY': (post_id) => `private-summary/${post_id}`,
    'SYNC_TO_S3' : (post_id) => `s3/${post_id}`,
    'UN_SYNC_TO_S3' : (post_id) => `s3/delete/${post_id}`,
    // 'GET_IP_BLOCK_SETTING': 'get-user-roles-settings',
    'GET_MEMBERS_SELECT' : (post_id) => `get-members-select/${post_id}`,
    CREATE_PRIVATE_URL_USER: (id) => `add-private-link-for-magic-link/${id}`,
    GET_PRIVATE_URL_USER: (id) => `get-private-link-for-magic-link/${id}`,
    CHECK_FILE_IS_DELETED_AND_SYNC: (id) => `check-file-is-deleted-and-sync/${id}`,
    INIT_DATA: 'init_data',
    ENCRYPT_FILE: 'encrypt-file',
    DECRYPT_FILE: 'decrypt-file',
}

export const AXIOS_CONFIG_IP_BLOCK = function() {
    return {
        baseURL: restApiRoot,
        timeout: 10000, //milisecond
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    }
}

export const AXIOS_CONFIG_PDA_IP_BLOCK = function() {
    return {
        baseURL: `${restApiRoot}/pda-ip-block/v1/`,
        timeout: 10000, //milisecond
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    }
}

export const AXIOS_CONFIG_PDA_MEMBERSHIPS_INTEGRATION = function() {
    return {
        baseURL: `${restApiRoot}/pda-memberships-integration/v1/`,
        timeout: 10000, //milisecond
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    }
}

export const AXIOS_CONFIG_STATS = function() {
    return {
        baseURL: `${restApiRoot}/pda-stats/`,
        timeout: 10000, //milisecond
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    }
}

export const AXIOS_CONFIG_S3 = function() {
    return {
        baseURL: `${restApiRoot}/wps3/v1/`,
        timeout: 20000, //milisecond
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    }
}

export const AXIOS_CONFIG_MAGIC_LINK = function() {
    return {
        baseURL: `${restApiRoot}/pda-magic-link/v1/`,
        timeout: 10000,
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    }
}

export const POST_TYPES = {
    PAGE: "page",
    POST: "post"
}

